import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';

import { BootComponent } from './boot.component';
import { MainGuard } from './guards/main.guard';
import { DataService } from './services/data.service';
import { TokenHttp } from './services/tokenhttp.service';
import { SharedModule } from './shared/shared.module';
import { UserRepository } from './repositories/user.repository';
import { CarrierRepository } from './repositories/carrier.repository';
import { LocationRepository } from './repositories/location.repository';
import { TourRepository } from './repositories/tour.repository';
import { DriverRepository } from './repositories/driver.repository';
import { DeliveryRepository } from './repositories/delivery.repository';
import { PickupRepository } from './repositories/pickup.repository';
import { CarrierLocationRepository } from './repositories/carrier-location.repository';
import { CarrierTourRepository } from './repositories/carrier-tour.repository';
import { CarrierDriverRepository } from './repositories/carrier-driver.repository';
import { DeliveryMessageRepository } from './repositories/delivery-message.repository';
import { ProductRepository } from './repositories/product.repository';
import { InvoiceRepository } from './repositories/InvoiceRepository';

@NgModule({
  declarations: [
    BootComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    SharedModule,
    RouterModule.forRoot([
      { path: '', loadChildren: './components/tours/tours.module#ToursModule' },
      {
        path: 'tours', loadChildren: './components/tour/tour.module#TourModule',
        data: {
          breadcrumb: "Kørsel",
          allowLink: false
        }
      },
      { path: 'carriers', loadChildren: './components/carriers/carriers.module#CarriersModule' },
      {
        path: 'carriers', loadChildren: './components/carrier/carrier.module#CarrierModule',
        data: {
          breadcrumb: "Vognmænd",
          allowLink: true
        }
      },
      { path: 'items', loadChildren: './components/items/items.module#ItemsModule' },
      {
        path: 'items', loadChildren: './components/items/items.module#ItemsModule',
        data: {
          breadcrumb: "Varer",
          allowLink: true
        }
      },
      { path: 'carrier', loadChildren: './components/carrier/carrier.module#CarrierModule' },
      { path: 'user', loadChildren: './components/user/user.module#UserModule' },
      { path: 'login', loadChildren: './components/login/login.module#LoginModule' },
      { path: 'delivery-messages', loadChildren: './components/delivery-messages/delivery-messages.module#DeliveryMessagesModule' },
      { 
        path: 'invoices', 
        loadChildren: "./components/invoices/invoices.module#InvoicesModule",
        data: {
          breadcrumb: "Fakturering",
          allowLink: true
        }
      },
      { path: '**', loadChildren: './components/notfound/notfound.module#NotfoundModule' },
    ])
  ],
  exports: [
    BrowserModule,
    HttpModule,
    SharedModule
  ],
  bootstrap: [BootComponent],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    MainGuard,
    DataService,
    UserRepository,
    CarrierRepository,
    LocationRepository,
    CarrierLocationRepository,
    CarrierTourRepository,
    CarrierDriverRepository,
    TourRepository,
    DriverRepository,
    DeliveryRepository,
    PickupRepository,
    InvoiceRepository,
    TokenHttp,
    DeliveryMessageRepository,
    ProductRepository,
  ]
})
export class BootModule { }

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
